import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { downloadPdf, remindVendor } from 'actions/maintenanceTicketActions';

import { getTranslatedString } from 'helpers/i18n';

import { AntdButton as Button } from '@yuhuinc/ui-library/';
import { featureEnabled } from 'helpers/ToggleBot';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledButton = styled(Button)`
  margin-left: 8px;
`;

const HeaderButtons = ({
  formProps,
  downloadPdf,
  showGeneratePDF,
  remindingVendor,
  remindVendor,
}) => {
  const { values, dirty } = formProps;

  const canRemindVendor = () => {
    if (!featureEnabled('maintenance.vendor_statuses_and_notifications')) {
      return false;
    }
    if (dirty || !values.assign || values.assign.type !== 'Vendor') {
      return false;
    }

    return ![
      'cancelled_dup',
      'cancelled',
      'cancelled_no_res',
      'Closed',
      'vendor_cancelled',
      'Fixed',
    ].includes(values.status);
  };

  return (
    <StyledContainer>
      {canRemindVendor() && (
        <StyledButton
          type="button"
          onClick={() => remindVendor(values.id)}
          label={getTranslatedString('landlordPortal.editMaintenanceTicketForm.remindVendor')}
          size="small"
          loading={remindingVendor}
        />
      )}
      {showGeneratePDF && (
        <StyledButton
          type="button"
          onClick={() => downloadPdf(values.id)}
          label={getTranslatedString('generatePDF')}
          size="small"
        />
      )}
    </StyledContainer>
  );
};
const mapStoreToProps = (store) => {
  return {
    remindingVendor: store.maintenanceTicket.remindingVendor,
  };
};
const mapDispatchToProps = {
  downloadPdf,
  remindVendor,
};

export default connect(mapStoreToProps, mapDispatchToProps)(HeaderButtons);
